export const dummyBlogPosts = [
  {
    title: '7 inspirasi outfit kasual stylish buat hangout santai bareng teman',
    image_banner: 'https://placehold.co/600x400/png?text=Blog+Image',
    name: 'fashion',
    content:
      '<p class="text-node">temukan inspirasi outfit kasual yang nyaman tapi tetap stylish untuk berbagai kesempatan hangout bareng teman.</p>',
    author: 'lia',
    slug: '7-inspirasi-outfit-kasual-stylish-buat-hangout-santai-bareng-teman',
    slug_category: 'fashion',
    created_at: '2025-06-12T09:15:42.000Z',
  },
  {
    title: 'panduan lengkap memilih peralatan dapur fungsional dan estetik',
    image_banner: 'https://placehold.co/600x400/png?text=Blog+Image',
    name: 'lifestyle',
    content:
      '<p class="text-node">tips memilih peralatan dapur yang nggak cuma fungsional tapi juga menambah estetika di rumah kamu.</p>',
    author: 'andre',
    slug: 'panduan-lengkap-memilih-peralatan-dapur-fungsional-dan-estetik',
    slug_category: 'lifestyle',
    created_at: '2025-07-20T14:48:05.000Z',
  },
];
